function TemporaryLanding() {
  return (
    <div className="holding-page">
      <div className="color-stripe" aria-hidden="true" />

      <header className="holding-header">
        <a className="holding-brand" href="/" aria-label="Stephen J. Martino home">
          <span className="brand-mark" aria-hidden="true">SJM</span>
          <span className="brand-name">Stephen J. Martino</span>
        </a>

        <span className="shop-status">
          <span className="status-dot" aria-hidden="true" />
          Flag shop open
        </span>
      </header>

      <main className="holding-main">
        <section className="holding-copy" aria-labelledby="holding-title">
          <p className="eyebrow">A quick pit stop</p>
          <h1 id="holding-title">
            The portfolio is getting a <span>fresh rebuild.</span>
          </h1>
          <p className="holding-intro">
            This site is temporarily offline while I make it better. In the meantime,
            my custom wooden American flag shop is still open and ready for you.
          </p>

          <div className="holding-actions">
            <a className="primary-link" href="/flags/">
              Visit the flag shop
              <span aria-hidden="true">&#8594;</span>
            </a>
            <p className="return-note">Portfolio returning soon.</p>
          </div>
        </section>

        <a className="flag-feature" href="/flags/" aria-label="Shop custom wooden American flags">
          <div className="feature-image-wrap">
            <img
              src="/assets/img/portfolio/A/WoodAmericanFlags/1.jpg"
              alt="A handcrafted wooden American flag by Stephen J. Martino"
            />
          </div>
          <div className="feature-caption">
            <div>
              <span className="caption-kicker">Handcrafted in the USA</span>
              <strong>Custom wooden flags</strong>
            </div>
            <span className="round-arrow" aria-hidden="true">&#8599;</span>
          </div>
        </a>
      </main>

      <footer className="holding-footer">
        <span>&copy; {new Date().getFullYear()} Stephen J. Martino</span>
        <a href="/flags/">stephenjmartino.com/flags</a>
      </footer>
    </div>
  );
}

export default TemporaryLanding;
